module.exports = __webpack_public_path__ + "static/media/M009-icon.b73cbdb9.svg";